import React, {Ref} from 'react';
import {reactCreateMemo, reactForwardRef} from "../react-utils/react-utils";

export const HtmlElement = reactCreateMemo(reactForwardRef(function HtmlElement<E extends HTMLElement> (props: HtmlElement.Props<E>) {

    const {
        tagName,
        ...htmlAttributes
    } = props;

    return React.createElement(tagName, htmlAttributes);
}));

export namespace HtmlElement {

    export interface Props<E extends HTMLElement> extends React.HTMLAttributes<any> {
        tagName: string;
        ref?: Ref<E>;
    }
}
